// styles.js
import { styled } from '@mui/material/styles';
import { Box, TextField, Typography, Paper, Button } from '@mui/material';

const dashedBox = (theme) => ({
//   background: '#f2f2f2',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
});

/* ——— outer layout ——— */
export const SalesContainer = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateRows: 'auto auto',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  width: '100%',
  margin: 'auto',

  [theme.breakpoints.down('sm')]: {
    width:'95%',
    padding: theme.spacing(1),
    marginLeft:'8%'
  },
  [theme.breakpoints.between('sm', 'md')]: {
    marginLeft: '2%',
  },
  [theme.breakpoints.between('md', 'lg')]: {
    marginLeft: '2%',
  },
}));

/* ——— main row ——— */
export const ContentRow = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)',
  gap: theme.spacing(2),

  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: 'minmax(0, 1fr)',
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: 'minmax(0, 1fr)',
  },
}));

export const Column = styled(Box)(({ theme }) => ({
  ...dashedBox(theme),
//   borderRadius: 12,
//   minHeight: 240,
display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  borderRadius: 12,
  minHeight: 240,
  paddingBottom: '40px',
}));

export const StyledTextField = styled(TextField)(({ theme, showDropdown }) => ({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: showDropdown ? '30px 30px 0 0' : '30px',
    transition: 'border-radius 0.3s ease',
    '&.Mui-focused fieldset': {
      borderColor: '#ddd',
      borderWidth:'1px'
    },
    '& fieldset': {
      borderColor: '#ddd', // default border color
    },
    '&:hover fieldset': {
      borderColor: '#ddd', // hover border color
    },
  },
  '& .MuiOutlinedInput-notchedOutline':{
     borderBottom: showDropdown && '0px',
  },
  
  borderBottom: showDropdown && '0px',
  boxSizing: 'border-box'
}));



export const CardWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: '12px 16px',
  marginTop: 8,
  borderRadius: 12,
  backgroundColor: '#ffffff',
  boxShadow: '0 1px 3px rgba(15, 23, 42, 0.08)',
  display: 'flex',
  flexDirection: 'column',
  cursor: 'pointer',
  transition: 'box-shadow 0.15s ease, transform 0.15s ease',
  '&:hover': {
    boxShadow: '0 4px 10px rgba(15, 23, 42, 0.16)',
    transform: 'translateY(-1px)',
  },
}));

export const TopRow = styled('div')({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: 8,
});

export const BottomRow = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  marginTop: 8,
});

export const BrandText = styled(Typography)({
  fontSize: '0.98rem',
  fontWeight: 600,
  lineHeight: 1.2,
  color:'#1976d2',
  textAlign:'left'
});

export const GenericText = styled(Typography)({
  fontSize: '0.78rem',
  color: '#6b7280',
  marginTop: 2,
});

export const MetaText = styled(Typography)({
  fontSize: '0.78rem',
  color: '#4b5563',
});

export const PriceText = styled(Typography)({
  fontSize: '0.98rem',
  fontWeight: 600,
  color: '#333',
});

export const CartWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'flex-end', // default desktop behavior

  // normal portrait mobile (optional: center too)
  [theme.breakpoints.down('md')]: {
    justifyContent: 'center',
    margin:'auto'
  },

  // ✅ specifically mobile landscape
  '@media (orientation: landscape) and (max-width: 900px)': {
    justifyContent: 'center',
  },
  
}));

export const CartCard = styled(Paper)(({ theme }) => ({
  width: '85%',
//   maxWidth: 360,
  padding: theme.spacing(3),
  borderRadius: 16,
  boxShadow: '0 4px 18px rgba(15, 23, 42, 0.10)',
  display: 'flex',
  flexDirection: 'column',
  marginBottom:'40px',

  [theme.breakpoints.down('sm')]: {
    width:'100%',
    padding: theme.spacing(1),
  },
}));

export const CartHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  marginBottom: 8,
});

export const CartItems = styled(Box)({
//   maxHeight: 260,
//   overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: 8,
});

export const CartEmptyState = styled(Box)({
  minHeight: 120,
  display: 'flex',
  flexDirection:'column',
  alignItems: 'center',
  justifyContent: 'center',
});

export const CartItemColumn = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection:'column',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  padding: theme.spacing(1.25),
  borderRadius: 12,
  backgroundColor: theme.palette.grey[50],
  border: `1px solid ${theme.palette.grey[200]}`,
}));

// export const CartItemRow = styled(Box)(({ theme }) => ({
//   display: 'flex',
//   justifyContent: 'space-between',
//   alignItems: 'flex-start',
//   padding: theme.spacing(1.25),
//   borderRadius: 12,
// }));

export const CartItemRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  padding: theme.spacing(1.25),
  borderRadius: 12,

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(1),
  },
}));

export const SmallRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
//   padding: theme.spacing(0.5),
  borderRadius: 12,
  width:'100%'
}));

export const CartItemInfo = styled(Box)({
  flex: 1,
  minWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  overflow:'hidden'
});

export const CartItemMeta = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
//   gap: 8,
//   marginTop: 4,
});

export const CartItemQty = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-end',
  marginLeft: theme.spacing(2),
  width:'50%',

  [theme.breakpoints.down('sm')]: {
    width: '100%',
    marginLeft: 0,
    alignItems: 'stretch',   // makes price rows fill width nicely
  },
}));

export const CartFooter = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
  marginTop: theme.spacing(2),
}));

export const TotalRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const TotalLabel = styled('span')(({ theme }) => ({
  fontWeight: 600,
  fontSize: 16,
  color: theme.palette.text.primary,

  [theme.breakpoints.down('sm')]: {
    fontSize:12
  },
}));

export const TotalValue = styled('span')(({ theme }) => ({
  fontWeight: 700,
  fontSize: 18,
  color:'#2563eb'
}));

export const CompleteButton = styled(Button)(({ theme }) => ({
  borderRadius: 999,
  paddingTop: theme.spacing(1.2),
  paddingBottom: theme.spacing(1.2),
  textTransform: 'none',
  fontWeight: 600,
  fontSize: 15,
}));

export const QtyButton = styled('button')(({ theme }) => ({
  width: 35,
  height: 35,
  borderRadius: 999,
  border: `1px solid #333`,
  backgroundColor: '#fff',
  cursor: 'pointer',
  fontSize: 22,
  lineHeight: '24px',
  textAlign: 'center',
  padding: 0,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.text.primary,
  '&:disabled': {
    opacity: 0.5,
    cursor: 'default',
  },
}));